export enum SpecialExamType {
  PASS_FAIL = 1,  // Предусмотрен допуск
  MARK = 2,       // Предусмотрена оценка
}



// WEBPACK FOOTER //
// ./src/app/common/enums/special-exam-type.enum.ts